import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface CheckoutDispatcherProps {
  configuration: GlobalPrivateState['configuration'];
  configurationId: string;
  checkout: GlobalPrivateState['checkout'];
  clientInfo: GlobalPrivateState['clientInfo'];
  dispatch: any;
}

const dispatchKey = 'checkout';

class CheckoutDispatcherContainer extends React.Component<CheckoutDispatcherProps> {

  componentDidMount() {
    this.dispatchCheckout();
  }

  componentDidUpdate(prevProps: CheckoutDispatcherProps) {    
    const { configuration } = this.props;
    const prevConfiguration = prevProps.configuration;

    const finishedUpdating = prevConfiguration.updating && !configuration.updating;
    const differentUpdate = (prevConfiguration.result && prevConfiguration.result.updated_at) !== (configuration.result && configuration.result.updated_at);
    if (finishedUpdating) {
      this.dispatchCheckout();
    }
  }

  public render() {
    return null;
  }

  private dispatchCheckout() {
    const url = this.orderId ? `/Orders/${this.orderId}` : `/Configurations/${this.props.configurationId}/checkout`;
    const method = this.orderId ? 'GET' : 'POST';

    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url,
        options: {
          method
        }
      },
      true
    ));
  }

  private get orderId(): string | undefined | null {
    const configuration = this.props.configuration.result;
    if (!configuration || (configuration && (isConfigurationEditable() || !configuration.orderId)) ) {
      return;
    }

    return configuration.orderId;
  }
}

export const CheckoutDispatcher = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
  clientInfo: state.clientInfo,
}))(CheckoutDispatcherContainer);
